export class AnalyticsModule {
	getAllGoogleAnalyticsInstances() {
		let instances = [];
		if (window && window.ga && window.ga.getAll) {
			instances = window.ga.getAll();
		}
		return instances;
	}
}